// src/views/pages/restaurant-reservations/waitlist/components/StatCard.jsx
import React from "react";
import { Card, Space } from "antd";

export default function StatCard({ title, value, icon, hint }) {
  return (
    <Card
      style={{
        borderRadius: 16,
        border: "1px solid #eef2f7",
        boxShadow: "0 10px 30px rgba(17,24,39,.04)",
      }}
      bodyStyle={{ padding: 14 }}
    >
      <Space align="start" style={{ width: "100%", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 700 }}>{title}</div>
          <div style={{ fontSize: 24, fontWeight: 900, color: "#111827", lineHeight: 1.2 }}>{value}</div>
          {hint ? <div style={{ marginTop: 6, fontSize: 12, color: "#6b7280" }}>{hint}</div> : null}
        </div>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 14,
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </div>
      </Space>
    </Card>
  );
}
